import { PostcodesGroupedByCity } from './groupPostcodesByCity'

export type CitiesGroupedByFirstLetter = Record<string, PostcodesGroupedByCity>

export const groupCitiesByLetter = (
  postcodesByCity: PostcodesGroupedByCity,
): CitiesGroupedByFirstLetter => {
  const emptyGrouping: CitiesGroupedByFirstLetter = {}
  const citiesGroupedByLetter = Object.keys(postcodesByCity).reduce(
    (grouped: CitiesGroupedByFirstLetter, city: string) => {
      const letter = city.charAt(0)
      return {
        ...grouped,
        [letter]: {
          ...grouped[letter],
          [city]: postcodesByCity[city],
        },
      }
    },
    emptyGrouping,
  )

  return citiesGroupedByLetter
}
